@if (extendedView) {
<div class="dab-item-extended mb-1">
  <div class="d-flex align-items-center justify-content-center">
    <fa-icon class="icon mr-2" [icon]="icon"></fa-icon>
    <span class="dab-item-extended__text">{{ text }}</span>
  </div>
  @if (quantity) {
  <div
    class="font-weight-bold d-flex justify-content-center dab-item-extended__quantity"
  >
    <span
      class="mr-1"
      i18n="PCard|dab item x character@@pcardProductDabItemXCharacter"
      >&#120;</span
    >
    <span data-e2e="p-card-product-item">{{ quantity }}</span>
  </div>
  }
</div>
} @else { @if (!extendedView) {
<div class="dab-item-minified">
  <fa-icon class="icon" [icon]="icon" [title]="text"></fa-icon>
  <p ngPreserveWhitespaces class="mb-0">
    @if (quantity) {
    <span data-e2e="p-card-product-item">{{ quantity }}</span>
    }
  </p>
</div>
} }
